<template>
	<section class="resultado">
		<router-view />
	</section>
</template>

<script>
export default {
	name: 'Resultado'
}
</script>
